<template>
  <div>
    <div style="
        background: white;
        padding: 20px;
        border-radius: 8px;
        /* box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1); */
      ">
      <div style="
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 1em 0;
        ">
        <span style="z-index: 1; background: white; padding: 0.1em 0.5em">
          {{ this.$i18n.t('subscription.cart_method.title') }}
        </span>
        <span style="
            position: absolute;
            left: 0;
            right: 0;
            height: 1px;
            background-color: #ccc;
          "></span>
      </div>
      <div style="margin-bottom: 20px">
        <span> Mon Abonnement </span>
        <input type="text" :style="formStyles.default" :value="this.subscriptionTypeString"
          disabled
        />
      </div>
      <div style="margin-bottom: 20px">
        <span> {{ this.$i18n.t('subscription.cart_method.form.email.name') }} </span>
        <input v-model="email" type="email" :style="validationErrors.email
            ? { ...formStyles.default, ...formStyles.error }
            : formStyles.default
            " @blur="validateField('email', emailPattern)"
          :placeholder="this.$i18n.t('subscription.cart_method.form.email.placeholder')" />
      </div>
      <div style="margin-bottom: 20px">
        <span>{{ this.$i18n.t('subscription.cart_method.form.full_name.name') }} </span>
        <input v-model="name" type="text" :style="validationErrors.name
            ? { ...formStyles.default, ...formStyles.error }
            : formStyles.default
            " @blur="validateField('name', namePattern)"
          :placeholder="this.$i18n.t('subscription.cart_method.form.full_name.placeholder')" />
      </div>
      <div style="margin-bottom: 20px">
        <span style=""> {{ this.$i18n.t('subscription.cart_method.form.cart_information.title') }} </span>
        <div style="
            display: flex;
            border: 1px solid #ccc;
            align-items: center;
            padding: 0;
            border-radius: 0.6em;
            flex-direction: column;
            overflow: hidden;
          ">
          <div style="
              display: flex;
              align-items: center;
              width: 100%;
              padding: 0;
              border-bottom: 1px solid #ccc;
              padding: 0.1em 0.5em;
            ">
            <input v-model="cardNumber" type="text"
              :placeholder="this.$i18n.t('subscription.cart_method.form.cart_information.cart_number.placeholder')"
              pattern="[0-9\s]{19}" :style="validationErrors.cardNumber
            ? { ...formStyles.borderlessDefault, ...formStyles.error }
            : formStyles.borderlessDefault
            " @blur="validateField('cardNumber', cardNumberPattern)" />
            <div style="display: flex; gap: 0.1em; margin-right: 0.5em">
              <img v-if="!cardType || cardType === 'MasterCard'"
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Mastercard-logo.svg/772px-Mastercard-logo.svg.png"
                alt="Mastercard" style="
                  height: 18px;
                  width: 25px;
                  padding: 0.1em 0.25em;
                  border-radius: 4px;
                  border: 1px solid #ccc;
                " />
              <img v-if="!cardType || cardType === 'Discover'"
                src="https://upload.wikimedia.org/wikipedia/commons/e/e5/DiscoverCard.svg" alt="Discover" style="
                  height: 18px;
                  width: 25px;
                  padding: 0.1em 0.25em;
                  border-radius: 4px;
                  border: 1px solid #ccc;
                " />
              <img v-if="!cardType || cardType === 'Visa'"
                src="https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg" alt="Visa" style="
                  height: 18px;
                  width: 25px;
                  padding: 0.1em 0.25em;
                  border-radius: 4px;
                  border: 1px solid #ccc;
                " />
              <img v-if="!cardType || cardType === 'Amex'"
                src="https://upload.wikimedia.org/wikipedia/commons/3/30/American_Express_logo.svg" alt="Amex" style="
                  height: 18px;
                  width: 25px;
                  padding: 0.1em 0.25em;
                  border-radius: 4px;
                  border: 1px solid #ccc;
                " />
            </div>
          </div>
          <div style="
              display: flex;
              gap: 0.1em;
              justify-content: center;
              align-items: center;
            ">
            <input v-model="cardExpiry" type="text"
              :placeholder="this.$i18n.t('subscription.cart_method.form.cart_information.experation_date.placeholder')"
              style="
                border-radius: 0;
                background: white;
                flex: 3;
                border: none;
                border-right: 1px solid #ccc;
              " pattern="[0-9]{2}/[0-9]{2}" @blur="validateField('cardExpiry', cardExpiryPattern)" />
            <input v-model="cardCvc" type="numeric" placeholder="CVC"
              style="background: #ffffff; width: 100%; flex: 2; border: none" pattern="[0-9]{3}"
              @blur="validateField('cardCvc', cardCvcPattern)" />
            <span style="margin-right: 0.5em"> CVC </span>
          </div>
        </div>
      </div>
      <div style="margin-bottom: 20px">
        <span> {{ this.$i18n.t('subscription.cart_method.form.region_infomation.title') }} </span>
        <div style="
            display: flex;
            margin-top: 0.1em;
            flex-direction: column;
            border: 1px solid #ccc;
            overflow: hidden;
            border-radius: 0.5em;
          ">
          <select v-model="cardCountry" style="
              border: 1px solid #ccc;
              background: white;
              margin-top: 0.1em;
              flex: 1;
              color: black;
              width: 100%;
              text-align: start;
              padding: 0.6em 1em;
              border: none;
            ">
            <option value="" disabled selected>Pays</option>
            <option value="US">United States</option>
            <option value="FR">France</option>
            <option value="CA">Canada</option>
          </select>
          <div style="flex: 1; border-top: 1px solid #ccc">
            <input v-model="cardPostalCode" type="numeric"
              :placeholder="this.$i18n.t('subscription.cart_method.form.region_infomation.code_postal.placeholder')"
              style="
                border: 1px solid #ccc;
                background: white;
                margin-top: 0.1em;
                border: none;
                padding: 0.6em 1em;
                border: none;
                width: 100%;
              " pattern="[0-9]{5}" />
          </div>
        </div>
      </div>
      <p v-if="submitError" style="
          color: red;
          font-size: 0.6em;
          display: flex;
          justify-content: center;
          align-items: center;
        ">
        <!-- TODO : pull from i18n instead -->
        <i>
          {{ submitError }}
        </i>
      </p>
      <div style="display: flex">
        <button :style="buttonStyles" @click="submitPayment" :disabled="!isFormValid">
          <strong>{{ this.$i18n.t('subscription.cart_method.action_buttons.submit') }}</strong>
        </button>
      </div>
      <div style="display: flex">
        <button :style="secondaryButtonStyles" @click="back_button">
          <strong>{{ this.$i18n.t('subscription.cart_method.action_buttons.back') }}</strong>
        </button>
      </div>
    </div>
   
  </div>
</template>

<script>
import { customLogger } from "../../utils";

export default {
  components: {
  },
  props: {
    subscriptionDetails: {
      type: Object,
      required : true,
    },
    redirect:{
      type: Function,
      required :true
    }
  },
  data() {
    return {
      validationErrors: {
        email: false,
        cardNumber: false,
      },
      emailPattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      namePattern: /^[a-zA-Z\s]{2,}$/,
      cardNumberPattern: /^(?:\d{4}\s?){3,5}$/,
      cardExpiryPattern: /^[0-9]{2}\/[0-9]{2}$/,
      cardCvcPattern: /^[0-9]{3}$/,
      email: "",
      name: "",
      submitError: null,
      cardNumber: "",
      cardType: null,
      cardExpiry: "",
      cardCvc: "",
      cardCountry: "",
      cardPostalCode: "",
      formStyles: {
        borderlessDefault: {
          border: " none",
          background: "white",
          marginTop: "0.1em",
          borderRadius: "0.6em",
          padding: "0.6em 1em",
          transition: "0.3s ease-in-out",
        },
        default: {
          border: " 1px solid #ccc",
          background: "white",
          marginTop: "0.1em",
          borderRadius: "0.6em",
          padding: "0.6em 1em",
          transition: "0.3s ease-in-out",
        },
        error: {
          color: "red",
          borderColor: "red",
          transition: "0.3s ease-in-out",
        },
        simpleError: {
          color: "red",
          transition: "0.3s ease-in-out",
        },
      },
    };
  },
  computed: {
    subscriptionTypeString(){
      let res = this.subscriptionDetails.type;
      let iString = {
        "monthly" : "Paiement par mois",
        "unique" : "Paiement unique"
      }
      res += " " + iString[this.subscriptionDetails.method]
      return res
      
    },
    isFormValid() {
      return (
        this.emailPattern.test(this.email) &&
        this.cardNumberPattern.test(this.cardNumber) &&
        this.cardNumber.length === 19 &&
        this.cardExpiry.length === 5 &&
        this.cardCvc.length >= 3 &&
        this.cardCountry.length >= 2 &&
        this.cardPostalCode.length >= 5
      );
    },
    secondaryButtonStyles() {
      return {
        display: "flex",
        flex: 1,
        padding: "0.6em",
        border: "none",
        borderRadius: "4px",
        justifyContent: "center",
        marginTop: "1em",
        background: "transparent",
        color: "#F4200B",
        border: "0.25em solid #F4200B",
        cursor: "pointer",
      };
    },
    buttonStyles() {
      return {
        display: "flex",
        flex: 1,
        padding: "0.6em",
        border: "none",
        backgroundColor: this.isFormValid ? "#021f5f" : "#d3d3d3",
        color: this.isFormValid ? "white" : "#a9a9a9",
        borderRadius: "4px",
        justifyContent: "center",
        gap: "0.5em",
        cursor: this.isFormValid ? "pointer" : "default",
      };
    },
  },
  watch: {
    cardNumber(newVal) {
      this.cardNumber = this.formatCardNumber(newVal);
      this.cardType = this.detectCardType(newVal);
    },
    cardExpiry(newVal) {
      let formattedExpiry = this.formatCardExpiry(newVal);
      if (this.isExpiryValid(formattedExpiry)) {
        this.cardExpiry = formattedExpiry;
        if (this.submitError === "errors.cardExpiryInvalid")
          this.submitError = null;
      } else {
        this.submitError = "errors.cardExpiryInvalid";
      }
    },
    cardCvc(newVal) {
      this.cardCvc = this.formatCvc(newVal);
    },
  },
  mounted() {
  },
  methods: {
    /**
     * @param {string} fieldName - name of the field to validate
     * @param {RegExp} pattern - pattern to validate the field against
     */
    validateField(fieldName, pattern) {
      try {
        // TODO refactor this method to be reusable same thing as login and signup
        if (!pattern.test(this[fieldName])) {
          this.$set(this.validationErrors, fieldName, true);
        } else {
          this.$set(this.validationErrors, fieldName, false);
        }
      } catch (e) {
        customLogger(e)
      }
    },
    /**
     * @param {string} value - card number to format
     * @return {string} formatted card number in format XXXX XXXX XXXX XXXX
     */
    formatCardNumber(value) {
      let v = value.replace(/\D/g, "");
      v = v.substring(0, 20);
      return v.replace(/(.{4})/g, "$1 ").trim();
    },
    /**
     * @param {string} expiry - card expiry to validate
     * @return {boolean} true if card expiry is valid
     */
    isExpiryValid(expiry) {
      let [month, year] = expiry.split("/").map(Number);
      month = parseInt(month);
      if (month < 1 || month > 12) return false;
      year += 2000;
      let expiryDate = new Date(year, month, 0);
      let currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);
      return currentDate < expiryDate;
    },
    /**
     * @param {string} value - card expiry to format
     * @return {string} formatted card expiry in format MM/YY
     */
    formatCardExpiry(value) {
      //Card Expiry date extract with regex the month can 1 or 2 digits and the year can be 2 digits
      const match = value.match(/^(\d{1,2})\/?(\d{2})/);
      if (!match) return "";

      //Extracting the month and year
      let month = match[1] || "";
      let year = match[2] || "";

      //Formatting the month
      if (month.length > 0) {
        month = month.padStart(2, "0");
      }

      //Formatting the year
      if (year.length > 0) {
        year = year.padStart(2, "0");
      }

      //Returning the formatted expiry date
      return `${month}/${year}`;
    },
    /**
     * @param {string} value - card cvc to format
     * @return {string} formatted card cvc in format XXX
     */
    formatCvc(value) {
      let v = value.replace(/\D/g, "");
      v = v.substring(0, 4);
      return v;
    },

    /**
     * @param {string} number - card number to detect type
     * @return {string} card type (Visa, MasterCard, American Express, etc)
     */
    detectCardType(number) {
      if (!number || number.length < 4) return null;
      const num = number.replace(/\D/g, "");
      const visaRegEx = /^4[0-9]{5}/;
      const mastercardRegEx =
        /^(5[1-5][0-9]{4}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)/;
      const amexRegEx = /^3[47][0-9]{4}/;
      const discoverRegEx = /^(6011|622[1-9]|64[4-9]|65)/;
      if (visaRegEx.test(num)) {
        return "Visa";
      } else if (mastercardRegEx.test(num)) {
        return "MasterCard";
      } else if (amexRegEx.test(num)) {
        return "Amex";
      } else if (discoverRegEx.test(num)) {
        return "Discover";
      } else {
        return "Unknown";
      }
    },

    async submitPayment() {

      try {
        this.$store.dispatch("SET_MODAL", {
          body: this.$i18n.t("subscription.payment.loading"),
          type: "loader",
        });
        const data = {
          email: this.email,
          name: this.name,
          card: {
            number: this.cardNumber,
            cvc: this.cardCvc,
            expiry: this.cardExpiry,
          },
          country: this.cardCountry,
          postalCode: this.cardPostalCode,
          subscriptionDetails : {
            type: this.subscriptionDetails.type,
            method: this.subscriptionDetails.method
          }
        };

        await this.$store
          .dispatch("HANDLE_PAYMENT", data)
          .then(async(res) => {
            customLogger(res);
            await this.$store.dispatch("SET_MODAL", {
              body: this.$i18n.t("subscription.payment.success"),
              type: "success"
            }).then(async () => {
              this.closeModal(true, res);
            });
          }
        )
          .catch((err) => {
            throw err;
          });
      } catch (error) {
        customLogger(error);
        this.$store.dispatch("SET_MODAL", {
          body: this.$i18n.t("subscription.payment.error"),
          type: "error",
        });
      }
    },
    async closeModal(success, intent) {
      if (success) {
        if (intent) {
          this.$store.commit(
            "SET_DATA_SUBSCRIPTION",
            intent
          );
          await this.$store.commit("SHOW_AUTH_FLOW", false);
          await this.$store.commit("SHOW_SUBS_FLOW", false);
          this.$store.state.user.user_session = {}
          this.$store.state.user.data = {}
          if (!this.$store.state.user.user_session)
            this.$store.state.user.user_session = {}
          this.$store.state.user.user_session.total_time_spent = 1
          this.$store.state.user.style_profile_key = "start";
          this.$eb.emit("BoxMounted", { from: "SubscriptionForm" });
        }
      }
    },
    back_button(){
      this.redirect('subscribe', null, null)
    },
  },
};
</script>
